import axios from 'axios';
let qs = require('qs');

let API_BASE = localStorage.getItem('api_base_url');

if (!API_BASE) {
    // API_BASE = 'https://gps.blackblox.si'
    API_BASE = process.env.VUE_APP_API_BASE;
}

let API_PATH = '/api/v2';
let API_URL = API_BASE + API_PATH;

function adaptDevice(device) {
    device.position = [device.lat, device.lon];
    delete device.lat;
    delete device.lon;
    delete device.speed; // speed seems to be outdated on /basic endpoint
    return device;
}

function storeData(data) {
    let expiry = new Date();
    expiry.setSeconds(expiry.getSeconds() + data.expires_in);

    localStorage.setItem('access_token', data.access_token);
    localStorage.setItem('refresh_token', data.refresh_token);
    localStorage.setItem('expires', expiry.toString());
    localStorage.setItem('username', data.username);
    localStorage.setItem('roles', data.roles);
}

export default class {
    constructor() {
        axios.defaults.withCredentials = true;
        axios.defaults.paramsSerializer = function(params) {
            return qs.stringify(params, { indices: false }); // param=value1&param=value2
        };

        axios.interceptors.request.use(
            (config) => {
                let ep = config.url.split('/').pop();
                if (ep === 'login' || ep === 'access_token') return config;
                let token = localStorage.getItem('access_token');
                if (token) {
                    let expiry = new Date(localStorage.getItem('expires'));
                    if (expiry > new Date()) {
                        config.headers['Authorization'] = `Bearer ${token}`;
                        return config;
                    } else {
                        return this.refresh(localStorage.getItem('refresh_token'))
                            .then((data) => {
                                config.headers['Authorization'] = `Bearer ${data.access_token}`;
                                return config;
                            })
                            .catch(error => {
                                console.log(error.stack);
                                throw new Error('reauth');
                            });
                    }
                } else {
                    return Promise.reject(new Error('reauth'));
                }
            },
            (error) => {
                return Promise.reject(error);
            }
        );
    }

    login(user) {
        return axios.post(API_BASE + '/api/login', user)
            .then(response => {
                storeData(response.data);
            })
            .catch(err => {
                if (err.response) {
                    throw new Error('credentials');
                } else if (err.request) {
                    throw new Error('connection');
                } else {
                    throw new Error('unknown');
                }
            });
    }

    refresh(refreshToken) {
        let data = new FormData();
        data.append('grant_type', 'refresh_token');
        data.append('refresh_token', refreshToken);
        return axios.post(API_BASE + '/oauth/access_token', data, {
            headers: { 'content-type': 'application/x-www-form-urlencoded' }
        })
            .then(response => {
                storeData(response.data);
                return response.data;
            });
    }

    fetchDevices() {
        return axios.get(API_URL + '/devices/basic', {})
            .then(response => {
                for (let device of response.data) {
                    device = adaptDevice(device);
                }
                return response.data;
            });
    }

    fetchDevice(deviceId) {
        return axios.get(API_URL + '/devices/' + deviceId, {})
            .then(response => {
                return response.data;
            });
    }

    fetchDeviceHistory(deviceId, params) {
        let config = {
            params: params
        };

        return axios.get(`${API_URL}/devices/${deviceId}/location-history`, config)
            .then(response => {
                return response.data;
            });
    }

    fetchVehicleReport(deviceId, params) {
        let config = {
            params: params
        };

        config.params['mobileReport'] = true;

        return axios.get(`${API_URL}/devices/${deviceId}/vehicle-report`, config)
            .then(response => {
                return response.data;
            });
    }

    updateAlarm(alarmSettings, deviceId) {
        return axios.post(API_URL + '/device/' + deviceId + '/alarms', alarmSettings)
            .then(response => {
                return response.data;
            });
    }

    getUserData() {
        return axios.get(`${API_URL}/user`, {})
            .then(response => {
                return response.data;
            });
    }
}
